import { Icon } from "../icon/icon";

export const InfoComponent = ({
  title,
  text,
  type,
}: {
  title: string;
  text: string;
  type: "error";
}) => {
  return (
    <div
      className={`rounded p-3 ${type === "error" && "bg-danger text-white"} flex gap-2`}
    >
      <Icon svg="info" width={20} height={20} />

      <div className="text-sm">
        <p className="font-bold">{title}</p>
        <p>{text}</p>
      </div>
    </div>
  );
};
